import { render, staticRenderFns } from "./defaultTable.vue?vue&type=template&id=4b675d68&scoped=true"
import script from "./defaultTable.vue?vue&type=script&lang=js"
export * from "./defaultTable.vue?vue&type=script&lang=js"
import style0 from "./defaultTable.vue?vue&type=style&index=0&id=4b675d68&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b675d68",
  null
  
)

export default component.exports